module.exports = new __parcel__URL__("helpdesk_text.5ac43639.png").toString();